<template>
  <StockProductEmbeddable v-model="form"/>
</template>
<script>
import stockProductEmbeddableMixin from "@/mixins/embeddable/stock/stockProductEmbeddableMixin"

export default {
  name: 'PolimixStockProduct',
  mixins: [stockProductEmbeddableMixin],
  data() {
    return {
      form: {},
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
}
</script>
